export const orange = {
  orangeLight0: '#FF901A',
  orange100: '#FFF1D1',
  orange200: '#FFDFA3',
  orange300: '#FFC975',
  orange400: '#FFB453',
  orange500: '#FF901A',
  orange600: '#DB7013',
  orange700: '#B7540D',
  orange800: '#933B08',
  orange900: '#7A2A04',
  orangeDefault: '#FF8400',
};
